import React from 'react';
import Modal from '../../containers/modal.jsx';
import Box from '../box/box.jsx';
import styles from './ae-readme-new.css';
import ReactMarkdown from 'react-markdown/with-html';
import readmeContent from '!raw-loader!../../../README.md';

const AEReadmeNewComponent = (props) => (
    <Modal
        className={styles.modalContent}
        onRequestClose={props.onClose}
        contentLabel="README"
        id="aeReadmeNew"
    >
        <Box className={styles.body}>
            <ReactMarkdown escapeHtml={false}>
                {readmeContent}
            </ReactMarkdown>
        </Box>
    </Modal>
);

export default AEReadmeNewComponent;